import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How long does cloud migration take?",
    answer: `<p>The timeframe for cloud migration varies based on factors like workload complexity, chosen migration method, and infrastructure scope. Generally, simple applications take around 2-2.5 months, while medium to complex apps may require 6+ months. Data warehouse migrations typically range from 2 to 8 months.</p>`,
  },
  {
    question: "How much does cloud migration services cost?",
    answer: `<p>Cloud migration costs depend on application complexity and modernization needs. For medium/large applications, expect costs between $150,000 to $500,000. Deep modernization efforts can exceed $500,000. Cloud data warehouse migrations for mid-sized companies range from $140,000 to $280,000, while larger enterprises may spend up to $500,000.</p>`,
  },
  {
    question: "How can I ensure my migration investments pay off?",
    answer: `<p>Maximize ROI by setting clear migration objectives, implementing cost-saving strategies, and leveraging cloud-native features for scalability. Monitor performance metrics post-migration, regularly review your cloud strategy, and optimize resource utilization to ensure migration investments yield significant returns.</p>`,
  },
  {
    question: "What are the key benefits of cloud migration?",
    answer: `<p>Cloud migration delivers scalability, agility, cost savings, enhanced security, and access to advanced services. Businesses benefit from streamlined operations, accelerated innovation, improved collaboration, and seamless digital experiences for customers.</p>`,
  },
  {
    question: "What is the primary goal of cloud migration?",
    answer: `<p>The main goal of cloud migration is to modernize IT infrastructure, improve scalability and flexibility, and reduce operational costs. It enables organizations to enhance data accessibility, deliver exceptional digital services, and stay competitive in a dynamic market.</p>`,
  },
  {
    question: "How does cloud migration impact application performance?",
    answer: `<p>Cloud migration can impact application performance, influenced by factors like network latency and resource allocation. However, optimizing application architecture, leveraging cloud-native services, and implementing performance monitoring tools ensure maintained or improved application performance post-migration.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Migration FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
